import { rem } from "polished";
import styled from "styled-components";

export const Wrapper = styled.div`
  img {
    border-radius: ${rem(20)};
  }
`;
